// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"a1e9f76d","152":"a895c858","213":"0e61e315","277":"2d34b599"}[chunkId] + ".chunk.js";
};